import ContainerValidator from "container-validator";

interface ContainerValidatorInstance {
    isValid(containerNumber: string): boolean;
    validate(containerNumber: string): void;
    getErrorMessages(): string[];
}

const containerValidator = new ContainerValidator() as ContainerValidatorInstance;

function validateContainerNumber(containerNumber: string | null | undefined): boolean {
    if (!containerNumber) {
        return false;
    }

    return containerValidator.isValid(containerNumber.toUpperCase());
}

function getContainerNumberErrorMessage(containerNumber: string | null | undefined): string[] | false {
    if (!containerNumber) {
        return false;
    }

    containerValidator.validate(containerNumber.toUpperCase());
    return containerValidator.getErrorMessages();
}

export { getContainerNumberErrorMessage, validateContainerNumber };
